import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DefaultLayoutComponent } from './layouts/default/default.component';
import { BoxedLayoutComponent } from './layouts/boxed/boxed.component';
import { DefaultCLayoutComponent } from './layouts/default-c/default-c.component';
import { BoxedCLayoutComponent } from './layouts/boxed-c/boxed-c.component';
import { ExtraLayoutComponent } from './layouts/extra/extra.component';
//import { PageDashboardComponent } from './pages/dashboard/dashboard.component';
import { PageNotFoundComponent } from './pages/not-found/not-found.component';
import { PageSignIn1Component }  from './pages/sign-in/sign-in';
import { PageLayoutsComponent } from './pages/layouts/layouts.component';
import { homepage} from './pages/home/home';

//mobile
import { PageProductionCheckSheet } from './pages/mobile/form-production-check-sheet';
import { PagePdCheckResult } from './pages/mobile/pd-check-result';
import { PageQcCheckSheet } from './pages/mobile/form-qc-check-sheet';
//product
import { PageProduct } from './pages/product/product';
import { PageProductAdd } from './pages/product/product-form-add';
import { PageProductEdit } from './pages/product/product-form-edit';
//matetial
import { PageMaterial } from './pages/material/material';
import { PageMaterialAdd } from './pages/material/material-form-add';
import { PageMaterialEdit } from './pages/material/material-form-edit';
//customer
import { PageCustomer } from './pages/customer/customer';
import { PageCustomerAdd } from './pages/customer/customer-form-add';
import { PageCustomerEdit } from './pages/customer/customer-form-edit';

//supplier
import { PageSupplier } from './pages/supplier/supplier';
import { PageSupplierAdd } from './pages/supplier/supplier-form-add';
import { PageSupplierEdit } from './pages/supplier/supplier-form-edit';
//Production line
import { PageProductionLine } from './pages/production-line/production-line';
//Machine
import { PageMachine } from './pages/machine/machine';
//approve
import { PageApprove } from './pages/approve/approve';
//permission 
import { PagePermission } from './pages/permission/permission';

//Process
import { PageProcess } from './pages/process/process';
//Plan process
import { PagePlanProcess } from './pages/plan-process/plan-process';

import { PageUser } from './pages/user/user';
import { PageUserPermission } from './pages/user/permission';
import { PageUserAdd } from './pages/user/user-add';
import { PageUserEdit } from './pages/user/user-edit';

//stock planning 
import { PageStockPlainning } from './pages/stock/stock-planning';

//control chart setting
//import { PageControlChartSetting } from './pages/control-chart-setting/control-chart-setting-cs';
import { PageControlChartSetting } from './pages/control-chart-setting/control-chart-setting';


import { PageProductStandard } from './pages/control-chart-setting/product-standard';

//import { PageControlChart } from './pages/mobile/form-control-chart';

import { PageOperatorSetting } from './pages/operator-setting/operator-setting';

import { PageCheckSheetSetting } from './pages/check-sheet-setting/check-sheet-setting';

//event
import { PageEvent }     from './pages/event/event';

//trade back
import { PageTradeTimeline } from './pages/trade-back/trade-timeline';
import { PageTradeList } from './pages/trade-back/trade-list';
import { PageTradeDelivery }  from './pages/trade-back/trade-delivery';
import { PageTradeDeliveryDetail } from './pages/trade-back/trade-delivery-detail';


//sale & delivery plan
import { PagePlanSale } from './pages/plan-sale/plan-sale';

const defaultRoutes: Routes = [

  { path : 'home',component:homepage},
  { path: 'check-sheet-setting', component: PageCheckSheetSetting },
  { path: 'operator-setting', component: PageOperatorSetting },
  { path: 'dashboard', loadChildren: './pages/dashboard/dashboard.module#mDashboardModule'},
  { path: 'layouts', component: PageLayoutsComponent },

  //production control

  // product
  { path: 'product', component: PageProduct },
  { path: 'trade-timeline/:id',component:PageTradeTimeline},
  { path: 'trade-list',component:PageTradeList},
  { path: 'trade-delivery',component:PageTradeDelivery},
  { path: 'trade-delivery-detail/:id',component:PageTradeDeliveryDetail},
  { path: 'product-form-add', component: PageProductAdd },
  { path: 'product-form-edit/:id', component: PageProductEdit },
  //material
  { path: 'material', component: PageMaterial },
  { path: 'material-form-add', component: PageMaterialAdd },
  { path: 'material-form-edit/:id', component: PageMaterialEdit },
  //customer
  { path: 'customer', component: PageCustomer },
  { path: 'customer-form-add', component: PageCustomerAdd },
  { path: 'customer-form-edit/:id', component: PageCustomerEdit },
  //machine
  { path: 'machine', component: PageMachine },
  //approve
  { path:'approve-document',component:PageApprove},
  //permissioon
  { path:'operator-permission',component:PagePermission},
  //process
  { path: 'process', component: PageProcess },
  //plan process
  { path: 'plan-process', component: PagePlanProcess },
  //control chart setting
  { path: 'control-chart-setting', component: PageControlChartSetting },
  { path: 'product-standard', component: PageProductStandard },
  //supplier
  { path: 'supplier', component: PageSupplier },
  { path: 'supplier-form-add', component: PageSupplierAdd },
  { path: 'supplier-form-edit/:id', component: PageSupplierEdit },
  //utility
  { path: 'utility', loadChildren: './pages/utility/utility.module#utilityModule' },
  //Bom

  { path: 'bom', loadChildren: './pages/bom/bom.module#bomModule' },
  
  //production line
  { path: 'production-line', component: PageProductionLine },

  //Report
  { path : 'fg-report',loadChildren:'./pages/report/m_module/fg.module#fgModule'},
  { path : 'rm-report',loadChildren:'./pages/report/m_module/rm.module#rmModule'},
  { path : 'pd-report',loadChildren:'./pages/report/m_module/pd.module#pdModule'},
  
  { path: 'event-setting',component:PageEvent},

  //sale & delivery plan
  {path:'sale-delivery-plan',component:PagePlanSale},


  //monitor
  //{ path: 'monitor-one', component: PageMonitorOne },
  //{path:'monitor',loadChildren:'./pages/monitor/m.module#mModule'},
  {path:'monitor-one',loadChildren:'./pages/monitor/m_module/m-one-monitor#mOneModule'},
  {path:'monitor-two',loadChildren:'./pages/monitor/m_module/m-two-monitor#mTwoModule'},
  {path:'monitor-three',loadChildren:'./pages/monitor/m_module/m-three-monitor#mThreeModule'},
  {path:'monitor-four',loadChildren:'./pages/monitor/m_module/m-four-monitor#mFourModule'},
  {path:'monitor-five',loadChildren:'./pages/monitor/m_module/m-five-monitor#mFiveModule'},
  {path:'monitor-six',loadChildren:'./pages/monitor/m_module/m-six-monitor#mSixModule'},
  {path:'monitor-seven',loadChildren:'./pages/monitor/m_module/m-seven-monitor#mSevenModule'},
  {path:'monitor-eight',loadChildren:'./pages/monitor/m_module/m-eight-monitor#mEightModule'},
  {path:'pd-monitor-4',loadChildren:'./pages/monitor/m_module/m-pd4-monitor#mPd4Module'},
  {path:'pd-monitor-5',loadChildren:'./pages/monitor/m_module/m-pd5-monitor#mPd5Module'},
  {path:'pd-monitor-6',loadChildren:'./pages/monitor/m_module/m-pd6-monitor#mPd6Module'},
  {path:'pd-monitor-7',loadChildren:'./pages/monitor/m_module/m-pd7-monitor#mPd7Module'},

  
  //print 
  { path: 'tracking-print', loadChildren: './pages/print/print.module#printModule'},


  //{ path: 'print/print-kanban-supplier/:key', component: PagePrintKanbanSupplier },

  //user
  { path: 'user', component: PageUser },
  { path: 'user-permission', component: PageUserPermission },
  { path: 'user-add', component: PageUserAdd },
  { path: 'user-edit/:id', component: PageUserEdit },
  //Warehouse
  { path: 'warehouse', loadChildren: './pages/warehouse/warehouse.module#warehouseModule' },

  //Stock planning
  { path: 'stock-planning', component: PageStockPlainning },

  //if not found
  { path: '**', component: PageNotFoundComponent },
];

const boxedRoutes: Routes = [
  {
     path: 'layouts', component: PageLayoutsComponent 
}
];

const boxedCRoutes: Routes = [
  { 
    path: 'layouts', component: PageLayoutsComponent 
  }
];

const defaultCRoutes: Routes = [
  { 
    path: 'layouts', component: PageLayoutsComponent 
  }

];

const extraRoutes: Routes = [
  { path: 'sign-in', component: PageSignIn1Component },

  //{ path: 'sign-in', loadChildren: './pages/sign-in/sign-in'},


  { path: 'control-chart', loadChildren: './pages/mobile/m_module/control-chart.module#mControlChartModule' },

  { path: 'mobile-prod-check-sheet', component: PageProductionCheckSheet },
  { path: 'moble-qc-check-sheet', component: PageQcCheckSheet },
  { path: 'moble-prod-check-result', component: PagePdCheckResult },

  { path: 'production-control', loadChildren: './pages/production-control/production-control.module#pdControlModule'},

  //{ path: 'monitor', loadChildren:'./pages/monitor/m.module#mModule'},
  {path:'pd-monitor-1',loadChildren:'./pages/monitor/m_module/m-pd1-monitor#mPd1Module'},
  {path:'pd-monitor-2',loadChildren:'./pages/monitor/m_module/m-pd2-monitor#mPd2Module'},
  {path:'pd-monitor-3',loadChildren:'./pages/monitor/m_module/m-pd3-monitor#mPd3Module'},
  {path:'pd-monitor-8',loadChildren:'./pages/monitor/m_module/m-pd8-monitor#mPd8Module'},
  {path:'pd-monitor-9',loadChildren:'./pages/monitor/m_module/m-pd9-monitor#mPd9Module'},
  
  {path:'fg-monitor-1',loadChildren:'./pages/monitor/m_module/m-fg1-monitor#mFg1Module'},
  {path:'fg-monitor-2',loadChildren:'./pages/monitor/m_module/m-fg2-monitor#mFg2Module'},
  {path:'fg-monitor-3',loadChildren:'./pages/monitor/m_module/m-fg3-monitor#mFg3Module'},
  {path:'rm-monitor-1',loadChildren:'./pages/monitor/m_module/m-rm1-monitor#mRm1Module'},
  {path:'rm-monitor-2',loadChildren:'./pages/monitor/m_module/m-rm2-monitor#mRm2Module'},
  {path:'rm-monitor-3',loadChildren:'./pages/monitor/m_module/m-rm3-monitor#mRm3Module'},
  {path:'rm-monitor-4',loadChildren:'./pages/monitor/m_module/m-rm4-monitor#mRm4Module'},
  {path:'rm-monitor-5',loadChildren:'./pages/monitor/m_module/m-rm5-monitor#mRm5Module'},
  {path:'rm-monitor-6',loadChildren:'./pages/monitor/m_module/m-rm6-monitor#mRm6Module'},
  {path:'rm-monitor-7',loadChildren:'./pages/monitor/m_module/m-rm7-monitor#mRm7Module'},
];

export const routes: Routes = [
  {
    path: '',
    //redirectTo: '/default-layout/dashboard',
    redirectTo: '/extra-layout/sign-in',
    pathMatch: 'full'
  },
  {
    path: 'default-layout',
    component: DefaultLayoutComponent,
    children: defaultRoutes
  },
  {
    path: 'default-c-layout',
    component: DefaultCLayoutComponent,
    children: defaultCRoutes
  },
  {
    path: 'boxed-layout',
    component: BoxedLayoutComponent,
    children: boxedRoutes
  },
  {
    path: 'boxed-c-layout',
    component: BoxedCLayoutComponent,
    children: boxedCRoutes
  },
  {
    path: 'extra-layout',
    component: ExtraLayoutComponent,
    children: extraRoutes
  },
  {
    path: '**',
    component: DefaultLayoutComponent,
    children: defaultRoutes
  }
];

@NgModule({
  imports: [],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }


// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/app-routing.module.ts